export const isValidHongKongNonPermanentID = (id: string) => {
  // const regex = /^[A-Z]\d{6}[A-Z0-9]$/;
  // return regex.test(id);
  const strValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (id.length < 8) {
    return false;
  }
  const str = id.toUpperCase();
  const hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
  const matchArray = str.match(hkidPat);
  if (matchArray == null) {
    return false;
  }
  const charPart = matchArray[1];
  const numPart = matchArray[2];
  const checkDigit = matchArray[3];
  let checkSum = 0;
  if (charPart.length == 2) {
    checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
    checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
  } else {
    checkSum += 9 * 36;
    checkSum += 8 * (10 + strValidChars.indexOf(charPart));
  }

  for (let i = 0, j = 7; i < numPart.length; i++, j--) {
    checkSum += j * Number(numPart.charAt(i));
  }
  const remaining = checkSum % 11;
  const verify = remaining == 0 ? 0 : 11 - remaining;
  return verify == Number(checkDigit) || (verify == 10 && checkDigit == 'A');
};

export const validateHKID = (hkid: string) => {
  // 香港身份证号码是8位，最后一位可以是数字或A-E的字母
  //
  console.log(hkid, 11111111);
  const strValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (hkid.length < 8) {
    return false;
  }
  const str = hkid.toUpperCase();
  const hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
  const matchArray = str.match(hkidPat);
  if (matchArray == null) {
    return false;
  }
  const charPart = matchArray[1];
  const numPart = matchArray[2];
  const checkDigit = matchArray[3];
  let checkSum = 0;
  if (charPart.length == 2) {
    checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
    checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
  } else {
    checkSum += 9 * 36;
    checkSum += 8 * (10 + strValidChars.indexOf(charPart));
  }

  for (let i = 0, j = 7; i < numPart.length; i++, j--) {
    checkSum += j * Number(numPart.charAt(i));
  }
  const remaining = checkSum % 11;
  const verify = remaining == 0 ? 0 : 11 - remaining;
  return verify == Number(checkDigit) || (verify == 10 && checkDigit == 'A');
};

export const isValidChinaID = (id: string) => {
  const regex = /^\d{17}[\dX]$/;
  if (!regex.test(id)) return false;

  const coefficients = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子
  const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; // 校验码对照表
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += Number(id[i]) * coefficients[i];
  }
  const mod = sum % 11;
  return checkCodes[mod] === id[17].toUpperCase(); // 注意大小写和校验码对照表的对应关系
};

export const isValidHKPassport = (passportNumber: string) => {
  // 1. 格式校验（不区分大小写）
  const formatRegex = /^[HKMhkm]\d{7}$/;
  if (!formatRegex.test(passportNumber)) return false;

  // 统一转为大写
  const normalized = passportNumber.toUpperCase();

  // 2. 将字母转换为数值（H=17, K=20, M=21）
  const charMap: { [key: string]: number } = { H: 17, K: 20, M: 21 };
  const firstCharValue = charMap[normalized[0]];

  // 3. 定义权重因子（[7,3,1,7,3,1,7,3]）
  const weights = [7, 3, 1, 7, 3, 1, 7, 3];

  // 4. 计算加权和（首字母 + 后续7位数字）
  let sum = 0;
  sum += firstCharValue * weights[0]; // 首字母的加权值

  // 处理后续7位数字（索引1到7）
  for (let i = 1; i < 8; i++) {
    const digit = parseInt(normalized[i], 10);
    sum += digit * weights[i];
  }

  // 5. 模10校验
  const checksum = sum % 10;
  return checksum === 0; // 有效护照号的校验和应为0
};

export const validatePassportNumber = (passportNumber: string) => {
  // 正则表达式：以一个大写字母开头，后跟8位数字
  const regex = /^[A-Z][0-9]{8}$/;
  return regex.test(passportNumber);
};
